// empty strings '' adds empty div to the dom to separate controls
// and to always have 2px border
export const mainFieldsGroup: any = [
  [
    'brandLabel', 'subBrand', 'partNumber',
    'basePartNumber', 'gtin', 'gtinQualifier', 'hasFitments', '',
  ],
  [
    'emissionCode', 'hazardousMaterialCode', 'taxable', '',
    'refurbishedPart', 'remanufacturedPart', 'productCondition', 'lifeCycleStatus',
    'nationalPopularityCode'
  ],
  [
    'partType', 'partTypeName', 'partCategory',
    'partSubcategory', 'productGroupId', 'productSubGroupId', '', '',
  ],
  [
    'containerType', ['itemQuantity', 'itemQuantityUom'],
    ['quantityPerApplication', 'quantityPerApplicationUom'],
    'quantityPerApplicationQualifier',
    ['minimumOrderQuantity', 'minimumOrderQuantityUom'],
    'effectiveDate', 'availableDate', 'category'
  ]
];

export const coreFieldsGroup: any = [
  [
    'coreId', 'coreGroup', 'coreReturnDaysToExpiry',
    'corePartNumber', 'returnCode',
    '', '', '',
  ]
];

export const partHistoryFieldsGroup: any = [
  [
    'oemBrand', 'oemPartNumber', 'originalSupplierName',
    'originalSupplierPartNumber', 'oldPartNumber', 'partNumberSupersededTo', '', ''
  ]
];

export const warrantyFieldsGroup: any = [
  [
    ['warrantyDistance', 'warrantyDistanceUom'],
    'warrantySpecial', 'warrantySpecialUom',
    ['warrantyTime', 'warrantyTimeUom'],
  ]
];

export const heavyDutyFieldsGroup: any = [
  ['unspscCode', 'vmrsCode', '', ''],
];
